import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
export const Footer = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  return <footer className="py-8 bg-gray-900 border-t border-gray-800 relative" data-id="element-44">
      {/* Subtle background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-45">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/subtle-dots.png')"
      }} data-id="element-46"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-47">
        <div className="text-center text-gray-300 text-sm" data-id="element-48">
          <p className="mb-4" data-id="element-49">
            Advertorial Note: This article is for informational purposes. The
            content comes from the new book When Schools Become Targets.
          </p>
          <div className="border-t border-gray-700 pt-4 mt-6" data-id="element-50">
            <button onClick={() => setIsPrivacyModalOpen(true)} className="text-gray-400 hover:text-white underline text-sm transition-colors" data-id="element-51">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
      {/* Privacy Policy Modal */}
      {isPrivacyModalOpen && <PrivacyPolicyModal onClose={() => setIsPrivacyModalOpen(false)} data-id="element-52" />}
    </footer>;
};